import { render, staticRenderFns } from "./Lecturer.vue?vue&type=template&id=69b90a06&"
import script from "./Lecturer.vue?vue&type=script&lang=js&"
export * from "./Lecturer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports